module.exports = __webpack_public_path__ + "static/media/icon_system_social_tiktok.49f2fab9.svg";